var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar-container",class:[{ online: _vm.online }]},[_c('div',{staticClass:"user-avatar"},[(_vm.isValidUrl)?[_c('img',{attrs:{"src":_vm.avatar,"alt":""}})]:[_c('p',[_vm._v("\n        "+_vm._s(_vm.initials)+"\n      ")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }